import * as types from "./socio.actionType";

export default {
  closeModalSocio: () => ({
    type: types.MODAL_SOCIO_CLOSE,
  }),
  openModalSocio: () => ({
    type: types.MODAL_SOCIO_OPEN,
  }),
  addSagaListSocio: (data) => ({
    type: types.ADD_SAGA_SOCIO_LISTGRID,
    payload: data,
  }),
  addStateListSocio: (data) => ({
    type: types.ADD_STATE_SOCIO_LISTGRID,
    payload: data,
  }),
  setSagaSocio: (data) => ({
    type: types.SET_SAGA_SOCIO,
    payload: data,
  }),
  setStateSocio: (data) => ({
    type: types.SET_STATE_SOCIO,
    payload: data,
  }),
  setSagaPrincipal: (id) => ({
    type: types.SET_SAGA_PRINCIPAL_SOCIO,
    payload: id,
  }),
  setStateListSocio: (id) => ({
    type: types.SET_STATE_LIST_GRID_SOCIO,
    payload: id,
  }),
  deleteSagaSocio: (id) => ({
    type: types.DELETE_SAGA_SOCIO_GRID,
    payload: id,
  }),
  setPrefix: (param) => ({
    type: types.SET_PREFIX_SOCIO,
    payload: param,
  }),
  getSolicitante: (param) => ({
    type: types.GET_SOLICITANTE,
    payload: param,
  }),
  setNewOpen: (param) => ({
    type: types.SET_NEW_OPEN,
    payload: param,
  }),
  setStateEnderecoSocio: (data) => ({
    type: types.SET_STATE_ENDERECO_SOCIO,
    payload: data,
  }),
  resetStateSocio: () => ({
    type: types.RESET_STATE_SOCIO,
  }),
};
